import { Routes, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { AppRoutes } from './app.routes';
import { APP_INITIALIZER, LOCALE_ID, ErrorHandler, InjectionToken, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { provideClientHydration, withI18nSupport } from '@angular/platform-browser';
import { CustomPreloader, RouterOptions, environment } from '@env/environment';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { Language, LanguagesService } from '@shared/services/languages/languages.service';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { HOST_URL } from '@shared/tokens/host-url';
import i18nIsoCountries, { LocaleData } from 'i18n-iso-countries';
// import { WindowToken, windowProvider } from '@shared/tokens/window';
import { APP_LANGUAGES } from './shared/tokens/app-languages';

import { GlobalErrorHandler } from './error-handler/global-error-handler';

import { PORTAL_LANGUAGES_EXT } from 'src/portal-language-ext';

import { MetadataService } from '@shared/services/meta-data-service/meta-data.service';
import { ApolloModule } from 'apollo-angular';

const routes: Routes = AppRoutes;

export const TINYMCE_SCRIPT_SRC = new InjectionToken<string>('TINYMCE_SCRIPT_SRC');


// Importa durante il bootstrap i file di localizzazione di angular e i18n-iso-country
// https://github.com/angular/angular-cli/issues/26409
// https://github.com/angular/angular-cli/issues/26904
// https://github.com/angular/angular/issues/23279
// { with: { type: 'json' } } non supportato da BABEL (Angular), ci vorrebbe anche module: esnext nel tsconfig
// https://dev.to/fkrasnowski/esnext-features-in-typescript-with-babel-36io
// Al momento ho copiato i json i18n-iso-country in file .js e li esporto come default.

export function appLocalesLoadFactory(localeId: string): () => Promise<any> {
  return (): Promise<any> => {
    const countriesLocale = new Promise((resolve, reject) => {
      import(
        // `i18n-iso-countries/langs/${localeId}.json`, { with: { type: 'json' } }
        `../assets/iso-countries/langs/${localeId}.js`
      )
        .then((lang) => {
          i18nIsoCountries.registerLocale(lang.default);
          resolve(lang);
        }, reject);
    });
    const angularGlobalLocale = new Promise((resolve, reject) => {
      if (localeId === 'en') {
        resolve(localeId);
      } else {
        const getLocale = (lang) => {
          switch(lang) { // work around ESBUILD, Stanno studiando se utilizzare API Intl
            case 'it':
              return import('@angular/common/locales/it');
            case 'fr':
              return import('@angular/common/locales/fr');
            case 'de':
              return import('@angular/common/locales/de');
            case 'es':
              return import('@angular/common/locales/es');
            case 'ru':
              return import('@angular/common/locales/ru');
          }
        }
        // import(`${environment.production ? '../../../' : ''}node_modules/@angular/common/locales/${localeId}.mjs`) // non funziona

        getLocale(localeId)
        .then(module => {
          registerLocaleData(module.default);
          resolve(localeId);
        }, reject);
      }
    });
    return Promise.all([countriesLocale, angularGlobalLocale]);
  };
}

export function tokenGetter(): string | null {
    return localStorage.getItem('token');
}

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            ApolloModule
        ),
        provideRouter(
            routes,
            withInMemoryScrolling(RouterOptions),
            // withPreloading(CustomPreloader)
        ),
        { provide: HOST_URL, useValue: environment.frontendUrl },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
       
        // { provide: WindowToken, useFactory: windowProvider }, // questo è nuovo, da vedere...
        { provide: 'FALLBACK_COMPANY_IMAGE', useValue: 'v1687436485/assets/generic-company-grey.svg' },
        { provide: 'FALLBACK_NEWS_IMAGE', useValue: 'v1649509226/assets/generic-news.jpg' },
        { provide: 'FALLBACK_PRODUCT_IMAGE', useValue: 'v1649509201/assets/generic-product.jpg' },
        { provide: 'FALLBACK_EVENT_IMAGE', useValue: 'v1649578160/assets/generic-event.png' },
        { provide: 'TINYMCE_API_KEY', useValue: '7otrhv6k3p3tj1uuo2baqj41quik1ycnjbxl7ojsa5weffb8' },
        { provide: 'GOOGLE_CLIENT_ID', useValue: environment.googleClientID },
        { provide: TINYMCE_SCRIPT_SRC, useValue: environment.tinyMce },
        { provide: APP_LANGUAGES, useValue: PORTAL_LANGUAGES_EXT.map(({code, name, flag}) => new Language(code, name, flag))},
        {
          provide: APP_INITIALIZER,
          useFactory: appLocalesLoadFactory,
          deps: [LOCALE_ID],
          multi: true
        }, 
        provideAnimationsAsync(),
        provideClientHydration(withI18nSupport()),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        LanguagesService,
        MetadataService
      ]
};


